import { useDispatch } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { get } from 'store/visitor-log'
import VisitorLogForm from './Form'
import VisitorCheckoutForm from './CheckoutForm'

export default function VisitorLogFormIndex() {
  const dispatch = useDispatch()
  const location = useLocation()
  const { id } = useParams()

  const action = location.state?.action
  const [visitorLog, setVisitorLog] = useState(null)

  useEffect(() => {
    if (id && id !== 'new') {
      dispatch(get({ id })).then(res => {
        setVisitorLog(res.payload)
      })
    } else {
      setVisitorLog(null)
    }
  }, [dispatch, id])

  if (id === 'new') {
    return <VisitorLogForm />
  }

  if (action === 'checkout' && visitorLog) {
    return (
      <VisitorCheckoutForm visitorLog={visitorLog} />
    )
  }

  return null
}